/**
 * @author       carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright    Copyright (c) 2021, Zumper
 */

import type { State } from '@zcode/state-type'

export const selectAppBannerShowing = (state: State) => state.appBanner.appBannerShowing
export const selectBannerAlreadyShown = (state: State) => state.appBanner.bannerAlreadyShown
